import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0799 2.00457C5.81786 2.49085 1.8425 6.98732 2.0048 12.2693C2.16709 17.5512 6.41102 21.7951 11.693 21.9574C16.9749 22.1197 21.4714 18.1444 21.9576 12.8823C22.0371 12.0222 21.0621 11.4727 20.3675 11.9862C17.9791 13.7516 14.6585 13.5039 12.5584 11.4038C10.4583 9.30369 10.2107 5.98312 11.9761 3.59473C12.4895 2.90009 11.94 1.92508 11.0799 2.00457ZM9.27789 4.43833L9.2405 4.54253C8.26027 7.37249 8.9301 10.6039 11.1442 12.818L11.3422 13.0094C13.548 15.0701 16.673 15.6731 19.4197 14.7217L19.5229 14.6833L19.4593 14.8581C18.2618 17.9456 15.2193 20.0648 11.7544 19.9584C7.52883 19.8285 4.13369 16.4334 4.00385 12.2078C3.89739 8.74288 6.01665 5.70045 9.10408 4.50294L9.27789 4.43833Z"
        fill="#191919"
      />
    </Svg>
  );
};

export default Icon;
